import {useIntl} from 'react-intl';
import {Center} from '@chakra-ui/react';

type DiscountBadgeProps = {
  discount: number;
};

export const DiscountBadge = ({discount}: DiscountBadgeProps) => {
  const format = useIntl().formatNumber;

  return (
    <Center
      boxSize="clamp(2rem, 5vw, 3.125rem)"
      rounded="full"
      bg="red.600"
      color="white"
      pos="absolute"
      top={[2, 3, null, 4]}
      insetInlineStart={[2, 3, null, 4]}
      fontWeight="900"
      fontSize="clamp(0.7rem, 1.6vw, 1rem)"
    >
      {format(discount, {style: 'percent', maximumFractionDigits: 2})}
    </Center>
  );
};
